import { BodyNode, ProgramNode } from "./ast";

export const toSource = (program: ProgramNode): string => {
  const walk = (node: BodyNode, openExpression: boolean): string => {
    switch (node.type) {
      case "Text":
      case "Identifier":
        return node.value;
      case "Expression": {
        let identifier = "";
        let prefix = openExpression ? "" : "${";

        if (node.identifier) {
          identifier = node.identifier.value.trim();
          prefix = openExpression ? "." : "${";
        }

        const property = node.property ? walk(node.property, true) : "}";

        return `${prefix}${identifier}${property}`;
      }
    }
  };

  return program.body.map((node) => walk(node, false)).join("");
};
